import React, { FunctionComponent } from "react";
import "./logo.scss";

export interface IconProps {
  animate: any;
}

const Icon: FunctionComponent<IconProps> = ({ animate }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1100 1240"
      className={`logo-svg ${animate ? "animate" : ""}`}
    >
      <path
        fill="#7b6bb0"
        d="M683.9,786.66c-209.19,0-378.77-169.58-378.77-378.77,0-34.03,4.49-67.01,12.9-98.38C156.39,352.71,37.33,500.18,37.33,675.46c0,108.65,45.74,206.61,119.02,275.68l259.75,259.75,259.75-259.75c2.72-2.57,5.41-5.17,8.05-7.82v-156.65Z"
      />
      <path
        fill="#ed145b"
        d="M683.9,29.12c-175.16,0-322.55,118.9-365.86,280.38,31.28-8.36,64.15-12.82,98.06-12.82,209.19,0,378.77,169.58,378.77,378.77,0,104.61-42.41,199.31-110.97,267.86h0l259.75-259.75c73.28-69.07,119.02-167.03,119.02-275.68,0-209.19-169.58-378.77-378.77-378.77Z"
      />
      <path
        fill="#4b2682"
        d="M416.1,296.69c-33.91,0-66.79,4.46-98.06,12.82-8.42,31.37-12.9,64.35-12.9,98.38,0,209.19,169.58,378.77,378.77,378.77v156.65c68.56-68.55,110.97-163.25,110.97-267.86,0-209.19-169.58-378.77-378.77-378.77Z"
      />
    </svg>
  );
};

export default Icon;
